import { API_ERROR, API_SUCCESS } from './types';
import { ENTITY_ALREADY_EXISTS, ENTITY_ALREADY_EXISTS_CONFLICT_MESSAGES } from '../utils/api-errors-const';

const AUTHORIZATION_HEADER = 'dietaniemowlaka-auth';

function getToken() {
  return localStorage.getItem('token');
}

export function hasToken() {
  return localStorage.getItem('token') !== null;
}

export function headerConfig() {
  const token = localStorage && hasToken ? getToken() : undefined;
  return token
    ? { headers: { [AUTHORIZATION_HEADER]: `Bearer ${token}` } }
    : {};
}

function createApiMessage(type, actionId, message) {
  return ({
    type: type,
    actionId: actionId,
    payload: {
      message: message,
    },
  });
}

export function apiSuccessMessage(message, actionId) {
  return createApiMessage(API_SUCCESS, actionId, message);
}

export function apiError(message, error, actionId) {
  const output = createApiMessage(API_ERROR, actionId, message);
  
  if (error && error.response) {
    const { data } = error.response;
    if (isDataOfServiceErrorType(data)) {
      output.payload.group = data.serviceErrorGroup;
      output.payload.details = data.message;
    } else {
      output.payload.message = `${output.payload.message} ${parseErrorContent(data)}`;
    }
  }
  
  return output;
}

export function dispatchError(error) {
  return dispatch => dispatch(apiError(error));
}

function isDataOfServiceErrorType(responseData) {
  return responseData && responseData.serviceErrorGroup;
}

function parseErrorContent(responseData) {
  return responseData && (responseData.errors || responseData.message) || responseData;
}

export function throwFieldsError(errorPayload, setErrors, setStatus) {
  const { serviceErrorGroup, message } = errorPayload;
  switch (serviceErrorGroup) {
    case ENTITY_ALREADY_EXISTS:
      const errors = {};
      message.split(';').forEach(field => field.includes('.') ?
        field.split('.').reduce((o, i) => Object.assign(errors, { [o]: { [i]: ENTITY_ALREADY_EXISTS_CONFLICT_MESSAGES[field] } }))
        : errors[field] = ENTITY_ALREADY_EXISTS_CONFLICT_MESSAGES[field]);

      setErrors(errors);
      if (setStatus) {
        setStatus(errors);
      }
  }
}